module.exports = __webpack_public_path__ + "img/ic_16_close_white.15ff9646.svg";